import { createFileRoute, notFound } from "@tanstack/react-router";
import { CatalogChildPage } from "@/components/sections/catalog-pages";
import { getCatalogChild } from "@/lib/services-catalog";

export const Route = createFileRoute("/services/industry-solutions/$child")({
  component: IndustryChild,
  head: ({ params }) => {
    const found = getCatalogChild("industry-solutions", params.child);
    const title = found ? `${found.item.title} — Industry Solutions — CoderLity` : "Industry Solutions — CoderLity";
    const desc = found?.item.desc ?? "Vertical software solutions.";
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: `/services/industry-solutions/${params.child}` },
      ],
      links: [{ rel: "canonical", href: `https://coderlity.com/services/industry-solutions/${params.child}` }],
    };
  },
});

function IndustryChild() {
  const { child } = Route.useParams();
  const found = getCatalogChild("industry-solutions", child);
  if (!found) throw notFound();
  return <CatalogChildPage cat={found.cat} item={found.item} />;
}
